import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "The Brik";
const SITE_URL = "https://www.the-brik.com";
const DEFAULT_IMAGE = `${SITE_URL}/images/metal-wallet-with-key-holder-and-tracking-card.jpg`;
const DEFAULT_IMAGE_ALT =
  "The Metal Brik wallet with ID, cards, cash, and keys all attached";

const SEO = ({
  title,
  description,
  path = "",
  image = DEFAULT_IMAGE,
  imageAlt = DEFAULT_IMAGE_ALT,
  type = "website",
  robots = "index, follow, max-image-preview:large",
  jsonLd,
  keywords,
  preloadModels = [],
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={robots} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {preloadModels.map((src) => (
        <link
          key={src}
          rel="preload"
          as="fetch"
          type="model/gltf-binary"
          href={src}
        />
      ))}

      {jsonLd &&
        (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((obj, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(obj)}
          </script>
        ))}
    </Helmet>
  );
};

export default SEO;
